import { useOpenWindow } from "@utils/window";
import { PAGES } from "@routes";
import Image from "@components/Image";
import { formatImgUrl } from "@utils/format";
import { Tag } from "antd";
import { Trans } from "react-i18next";
import { FocusAction } from "./FocusAction";
import type { UICardProps } from "./types";

const UIScriptCard = ({ record }: UICardProps) => {
  const { openWindow } = useOpenWindow();

  return (
    <div
      key={record.id}
      className="kalo-white-card flex w-full group relative p-[16px] cursor-pointer overflow-hidden"
      onClick={() => {
        if (record.from === "/insight" || record.from === "/aiStudio/script-export") {
          openWindow(
            `${PAGES.AI_VIDEO_INSIGHT}?id=${record.id}&collectionId=${record.collectionId}&videoSource=${record.videoSource || "Kalodata"}`,
          );
        } else {
          openWindow(
            `${PAGES.AI_SCRIPT_REVIEW}?id=${record.id}&collectionId=${record.collectionId}&videoSource=${record.videoSource || "Kalodata"}`,
          );
        }
      }}
    >
      <Image
        className="w-[90px] h-[140px] mr-[8px] border-none! shrink-0"
        url={record.coverImageUrl}
        hoverEnlarge={record.id ? true : false}
      ></Image>
      <div className="flex flex-col gap-[12px] flex-1 min-w-0">
        <div className="font-semibold truncate text-kds-fg line-clamp-1">{record.name}</div>
        <div className="flex items-center gap-[8px] min-w-0">
          <Image
            className="w-[32px] h-[32px] shrink-0 rounded-[4px] overflow-hidden"
            url={formatImgUrl("product", record.productId)}
            hoverEnlarge={true}
          ></Image>
          {record.productName ? (
            <div className="line-clamp-2 font-normal text-[13px] text-kds-fg leading-[18px] min-w-0 flex-1">
              {record.productName}
            </div>
          ) : (
            <div className="text-[13px] text-kds-fg-subtle">
              <Trans>No promotable products</Trans>
            </div>
          )}
        </div>
        <div className="flex flex-wrap gap-[8px] h-[52px] overflow-hidden items-baseline">
          {record?.scenes?.map((item: any, index: number) => (
            <Tag className="rounded-full! text-[12px]" key={item + index}>
              <Trans>{item}</Trans>
            </Tag>
          ))}
        </div>
      </div>
      <FocusAction
        className="absolute right-[11px] top-[11px] hidden group-hover:flex"
        id={record.collectionId}
        type="script"
      ></FocusAction>
    </div>
  );
};

export default UIScriptCard;
